import React from "react";
import styled from "styled-components";

// ─── Spacing scale: 8 12 16 20 24 32 40 48 56 64 80 96 ───────────────────────

// ─── Layout ──────────────────────────────────────────────────────────────────

export const SectionContainer = styled.section<{ maxWidth?: string }>`
  padding: 80px 24px;
  max-width: ${(p) => p.maxWidth ?? "960px"};
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 56px 20px;
  }
  @media (max-width: 480px) {
    padding: 40px 16px;
  }
`;

export const SectionInner = styled.div<{ maxWidth?: string }>`
  max-width: ${(p) => p.maxWidth ?? "960px"};
  margin: 0 auto;
`;

export const HeadingArea = styled.div`
  text-align: center;
  margin-bottom: 40px;
  @media (min-width: 768px) {
    margin-bottom: 48px;
  }
`;

export const ButtonCenter = styled.div`
  text-align: center;
`;

// ─── Typography ──────────────────────────────────────────────────────────────

export const SectionHeadline = styled.h2`
  font-size: clamp(1.5rem, 5vw, 4rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${(p) => (p.theme.isDarkMode ? "#ffffff" : "#0F172A")};
  margin: 0;
`;

// ─── Buttons ─────────────────────────────────────────────────────────────────

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
  padding: 14px 32px;
  background: #2563eb;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  width: 100%;
  max-width: 320px;
  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.25);
  transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
  &:hover {
    background: #1d4ed8;
    box-shadow: 0 14px 40px rgba(37, 99, 235, 0.3);
    transform: scale(1.02);
  }
  @media (min-width: 480px) {
    width: auto;
    min-width: 200px;
    font-size: 1.0625rem;
    padding: 16px 40px;
  }
`;

// ─── Icons ───────────────────────────────────────────────────────────────────

export const CalendarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const CopyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);
